//Library Imports
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { Row, Col, Typography } from "antd";

//Local Imports
import ButtonRightIcon from "modules/Common/Components/ButtonRightIcon";
import Speed from "../../../../../assets/img/icons/Speed.svg";
import Send from "../../../../../assets/img/icons/Send.svg";
import BlankProfilePhoto from "../../../../../assets/img/blank_profile_photo.png";
import { XIQ_SALES_XELERATOR_URL } from "constants/index";
import { IContactsItem } from "modules/Analytics/interfaces";
import Logo from "../../../../../assets/img/xiqPlaceholder.jpg";

//Style Imports
import styled from "styled-components";
import { addCommaToNumber } from "utils";

const ContactDetailsCard = () => {
  const contactDetails: IContactsItem = useSelector(
    (state: RootState) => state.contactInnerDetails.dashboard.contact_details
  );
  const { Paragraph, Text } = Typography;
  // const [ellipsis, setEllipsis] = React.useState(true);
  // https://salesapp.xiqonline.com/person/personalityinsights?personId=1317&personType=EXECUTIVE
  return (
    <>
      {contactDetails !== undefined && Object.keys(contactDetails)?.length > 0 && (
        <Wrapper color={contactDetails?.personality?.color}>
          <h3 className="heading-profile">Contact Details</h3>
          <div className="default-profile">
            <div className="top-row">
              <div className="send-btn">
                {contactDetails?.person_id && (
                  <a
                    href={`${XIQ_SALES_XELERATOR_URL}person/personalityinsights?personId=${contactDetails?.person_id}&personType=EXECUTIVE`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <ButtonRightIcon label="Sales Xelerator" icon={Send} />
                  </a>
                )}
              </div>
            </div>
            <div className="middle-row">
              <Row gutter={24}>
                <Col span="12" className="gutter-row d-flex align-items-center justify-content-end">
                  <div
                    className="badge-wrapper"
                    style={{
                      backgroundColor: contactDetails?.personality?.color
                        ? contactDetails?.personality?.color
                        : "#ffffff",
                    }}
                  >
                    <img
                      src={contactDetails?.contact_image ? contactDetails?.contact_image : BlankProfilePhoto}
                      alt=""
                    />
                    <span
                      className="badge-name"
                      style={{
                        backgroundColor: contactDetails?.personality?.color
                          ? contactDetails?.personality?.color
                          : "#ffffff",
                      }}
                    >
                      {contactDetails?.personality?.archetype}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row gutter={24} className="pt-2 mb-2 user-row">
                <Col span="16" className="gutter-row d-flex align-items-center">
                  <h6 className="user-name">
                    {contactDetails?.contact_name?.trim() !== "" ? (
                      <Paragraph ellipsis={{ rows: 2, tooltip: contactDetails?.contact_name }}>
                        {contactDetails?.contact_name}
                      </Paragraph>
                    ) : (
                      <Paragraph ellipsis={{ rows: 2, tooltip: contactDetails.contact_email }}>
                        {contactDetails.contact_email}
                      </Paragraph>
                    )}
                  </h6>
                </Col>
                <Col span="8" className="align-self-center">
                  <div className="engagement">
                    <img src={Speed} />
                    &nbsp;
                    {addCommaToNumber(contactDetails?.lifetime_score?.toString() ?? "")}
                  </div>
                </Col>
              </Row>
              {contactDetails?.company_name !== "" ? (
                <Row gutter={24}>
                  <Col span="24" className="gutter-row">
                    <div className="comapny-row d-flex">
                      <div className="company-logo">
                        {contactDetails?.company_logo ? (
                          <img
                            src={contactDetails?.company_logo ? contactDetails?.company_logo : Logo}
                            alt="PersonImage"
                          />
                        ) : (
                          <img src="https://media.xiq.io/static/default_campaign_img.png" alt="PersonImage" />
                        )}
                      </div>
                      <div className="company-details flex-grow-1">
                        <p className="name mb-0"> {contactDetails?.company_name}</p>
                        {contactDetails?.job_title ? <p className="designation mb-0"> {contactDetails?.job_title}</p> : <div className="emptyDivForHeightFix"></div>}
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : <div style={{ height: '37px' }}></div>}
            </div>
          </div>
        </Wrapper>
      )}
    </>
  );
};

export default ContactDetailsCard;

const Wrapper = styled.div`
  .emptyDivForHeightFix{
    height: 20px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 15px;
    }
  }
  .heading-profile {
    width: 100%;
    color: #424b50;
    font-size: 23px;
    font-family: "Roboto Slab", serif;
    font-weight: 400;
    margin-bottom: 24px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .default-profile {
    background: white;
    padding: 18px 24px;
    border-radius: 10px;
    box-shadow: 0px 0px 17px -2px rgb(0 0 0 / 8%);
  }
  .badge-wrapper {
    height: 100%;
    border-radius: 50%;
    background-color: #f0b520;
    position: relative;
    min-height: 180px;
    min-width: 180px;
    transform: translate(50%, 0px);
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-height: 106px;
      min-width: 106px;
    }
    img {
      border-radius: 50%;
      width: 174px;
      height: 174px;
      position: absolute;
      top: 3px;
      left: 3px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        width: 100px;
        height: 100px;
      }
    }
    .badge-name {
      background-color: #f0b520;
      font-family: "robotomedium";
      letter-spacing: 1px;
      font-weight: 400;
      font-size: 10px;
      color: #fff;
      padding: 2px 7px;
      position: absolute;
      bottom: -5px;
      left: 50%;
      border-radius: 9px;
      width: auto;
      transform: translateX(-50%);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 8px;
        border-radius: 6px;
      }
    }
  }
  .engagement {
    border-radius: 12px;
    background-color: #1971eb;
    color: #ffffff;
    font-size: 16px;
    font-family: "robotomedium";
    font-weight: 500;
    padding: 0px 10px;
    display: inline;
    float: right;
    min-width: 75px;
    text-align: center;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      padding: 0px 8px 2px 6px;
      border-radius: 9px;
    }
    img {
      float: left;
      margin-top: 7px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 5px;
      }
    }
  }
  .user-row {
    height: 100px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 76px;
    }
    .user-name {
      color: #424b50;
      font-size: 35px;
      line-height: 40px;
      margin-bottom: 0px;
      display: inline-block;
      font-family: "Roboto Slab", serif;
      width: calc(100% - 35px);
      float: left;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 28px;
        line-height: 34px;
      }
      @media all and (max-width: 1800px) {
        font-size: 28px;
        line-height: 34px;
        width: 100%;
        .ant-typography {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block !important;
        }
      }

      div.ant-typography,
      .ant-typography p,
      a.ant-typography-ellipsis,
      span.ant-typography-ellipsis {
        margin: 0;
        max-width: 100%;
        /* overflow-wrap: normal; */
        /* display: block; */
        display: -webkit-box;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          display: -webkit-box;
        }
      }
    }
  }

  .default-profile {
    div.engagement-chart {
      margin-top: 30px;
    }
    h4.recommended-title {
      color: #7e7e7e;
      font-size: 18px;
      font-weight: 400;
      font-family: "Roboto Slab", serif;
      margin: 30px 0 16px 0;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
        margin: 20px 0 10px 0;
      }
    }
    .top-row {
      position: relative;
      padding-top: 13px;
      min-height: 50px;
      .profile-pic {
        position: relative;
        text-align: center;
        padding-top: 15px;
        z-index: 0;
        img {
          border: ${(props) => `4px solid ${props.color}`};
          max-width: 175px;
          height: 175px;
          border-radius: 100%;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            max-width: 125px;
            height: 125px;
          }
        }
        span {
          background: ${(props) => props.color};
          padding: 2px 12px;
          border-radius: 15px;
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translate(-50%, 0);
          font-size: 18px;
          font-weight: 500;
          font-family: "Roboto", sans-serif;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            border-radius: 11px;
            font-size: 13px;
          }
        }
      }
      .send-btn {
        position: absolute;
        right: 0;
        top: 0px;
        z-index: 1;
      }
    }
    .middle-row {
      .loader {
        svg {
          max-width: 100%;
        }
      }
      .comapny-row {
        .company-logo {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 28px;
            height: 28px;
            border-radius: 6px;
          }
          img {
            width: 40px;
            height: 40px;
            border-radius: 8px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              width: 28px;
              height: 28px;
              border-radius: 6px;
            }
          }
        }
        .company-details {
          margin-bottom: 6px;
          padding: 0 12px;
          .name {
            font-family: "Roboto", sans-serif;
            font-weight: 500;
            color: #424b50;
            font-size: 18px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 13px;
              line-height: 16px;
            }
          }
          .designation {
            font-size: 14px;
            color: #27ce0a;
            font-weight: 500;
            font-family: "Roboto", sans-serif;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              font-size: 10px;
              line-height: 17px;
            }
          }
        }
        .name {
          width: 100%;
          input {
            width: 100%;
          }
          .tooltip {
            position: relative;
            display: inline-block;
            opacity: 1;
            z-index: 0;
            .tooltiptext {
              color: #ffffff;
              font-size: 11px;
              letter-spacing: 0.02px;
              line-height: 15px;
              text-align: center;
              background-color: #263153;
              visibility: hidden;
              border-radius: 4px;
              padding: 5px 0;
              position: absolute;
              z-index: 1;
              bottom: 125%;
              left: 50%;
              transform: translateX(-50%);
              opacity: 0;
              transition: opacity 0.3s;
              padding: 5px 10px;
              &:after {
                content: "";
                position: absolute;
                top: 100%;
                left: 50%;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
                border-color: #263153 transparent transparent transparent;
              }
            }
            &:hover .tooltiptext {
              visibility: visible;
              opacity: 1;
            }
          }
        }
      }
    }
  }
`;
